import React from "react";
import Button from "./form/Button";

export const SelectedOrganisationsCard = ({
  selectedOrganisations = [],
  onDeleteOrganisation,
}) => {
  return (
    <div className="selected-organisation">
      <h2 className="paragraph-md semibold text-neutral-950">Organisation</h2>
      <p className="paragraph-md">Selected organisations</p>

      <div className="selected-organisation__options">
        {selectedOrganisations
          ? selectedOrganisations.map((item, index) => {
              return (
                <div className="selected-organisation__item" key={index + 300}>
                  <div className="selected-organisation__info">
                    <div className="logo-box">
                      <img
                        className="logo-box__image"
                        src={item.Organisation_Logo_Path}
                        alt={`Logo: ${item.Organisation_Name}`}
                      />
                    </div>
                    <p className="paragraph-md semibold paragraph-md--dark">
                      {item.Organisation_Name}
                    </p>
                  </div>
                  <Button
                    variant="danger"
                    compact
                    onClick={() => onDeleteOrganisation(item.Organisation_ID)}
                  >
                    Delete
                  </Button>
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
};
